import { Link as GatsbyLink } from 'gatsby'
import React from 'react'

interface LinkProps {
  href: string
  onClick?: () => void
  id?: string
  style?: { [key: string]: string }
  children?: React.ReactChild
  color?: string

  //NOTE force as external link, used in the bottom section of footer
  isExternal?: boolean
}

const Link = ({ href, id, style, isExternal, ...restProps }: LinkProps) => {
  if (
    isExternal ||
    href.startsWith('http') ||
    href.startsWith('mailto:') ||
    // NOTE removed header and footer on all `/privacy/xxx` path page, therefore need a new tab for privacies
    href.startsWith('/privacy')
  ) {
    return (
      <a
        href={href}
        id={id}
        target="_blank"
        rel="noopener noreferrer"
        style={style}
        {...restProps}
      />
    )
  }

  return <GatsbyLink to={href} activeStyle={style} {...restProps} />
}

export default Link
